<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 10:17:48
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-28 17:57:30
-->
<template>
  <div>
    <div class="top">
      <div class="back">
        <img
          @click="backPage"
          class="add-img"
          src="@/assets/images/back.jpg"
        />新增申请
      </div>
    </div>
    <div  class="form">
      <el-form
        :model="ruleForm"
        :style="{height:height}"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form
          :rules="rules"
          ref="ruleFormBase"
          label-width="90px"
          class="demo-ruleForm base_seting"
          :model="ruleForm"
        >
          <div class="title">
            <div class="icon-title"></div>
            <div class="title-txt">申请人信息</div>
          </div>
          <el-form-item label="申请类型" prop="applyType">
            <div style="width: 80%" class="status">
              <el-radio v-model="ruleForm.applyType" label="0">公民</el-radio>
              <el-radio v-model="ruleForm.applyType" label="1"
                >法人/其他组织</el-radio
              >
            </div>
          </el-form-item>
          <el-form-item v-if="ruleForm.applyType == 0" label="姓名" prop="name">
            <el-input
              style="width: 80%"
              v-model="ruleForm.name"
              placeholder="请输入公民姓名"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="ruleForm.applyType == 0"
            label="证件名称"
            prop="certificateType"
          >
            <el-select
              style="width: 80%"
              v-model="ruleForm.certificateType"
              placeholder="请选择"
            >
              <el-option label="身份证" value="0"></el-option>
              <el-option label="工作证" value="1"></el-option>
              <el-option label="学生证" value="2"></el-option>
              <el-option label="军官证" value="3"></el-option>
              <el-option label="护照" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="ruleForm.applyType == 0"
            label="证件号码"
            prop="certificateNumber"
          >
            <el-input
              style="width: 80%"
              v-model="ruleForm.certificateNumber"
              placeholder="请输入证件号码"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="ruleForm.applyType == 1"
            label="类型"
            prop="organizationType"
          >
            <el-select
              style="width: 80%"
              v-model="ruleForm.organizationType"
              placeholder="请选择"
            >
              <el-option label="商业企业" value="0"></el-option>
              <el-option label="科研机构" value="1"></el-option>
              <el-option label="社会公益组织" value="2"></el-option>
              <el-option label="法律服务机构" value="3"></el-option>
              <el-option label="其他" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.applyType == 1" label="名称" prop="name">
            <el-input
              style="width: 80%"
              v-model="ruleForm.name"
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="ruleForm.applyType == 1"
            label-width="140px"
            label="统一社会信用代码"
            prop="socialCreditCode"
          >
            <el-input
              style="width: 78%"
              v-model="ruleForm.socialCreditCode"
              placeholder="请输入统一社会信用代码"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="ruleForm.applyType == 1"
            label="法定代表"
            prop="statutoryRepresentative"
          >
            <el-input
              style="width: 80%"
              v-model="ruleForm.statutoryRepresentative"
              placeholder="请输入法人代表"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="ruleForm.applyType == 1"
            label-width="100px"
            label="联系人姓名"
            prop="contactName"
          >
            <el-input
              style="width: 80%"
              v-model="ruleForm.contactName"
              placeholder="请输入联系人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" required>
            <el-form-item label="手机" prop="phone" label-width="50px">
              <div style="display: flex">
                <el-input
                  style="width: 78%"
                  v-model="ruleForm.phone"
                  placeholder="请输入手机号码"
                ></el-input>
              </div>
            </el-form-item>

            <div style="display: flex; margin-top: 20px">
              <div style="width: 40px">座机</div>
              <a-input-group style="width: 80%" compact>
                <a-input
                  v-model="ruleForm.quhao"
                  type="number"
                  style="width: 20%; height: 40px"
                  placeholder="区号"
                />
                <a-input
                  v-model="ruleForm.num"
                  type="number"
                  style="width: 71%; height: 40px"
                />
              </a-input-group>
            </div>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email">
            <el-input
              style="width: 80%"
              v-model="ruleForm.email"
              placeholder="请输入电子邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮政编码" prop="postalCode">
            <el-input
              style="width: 80%"
              v-model="ruleForm.postalCode"
              placeholder="请输入邮政编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="通信地址" prop="contactAddress">
            <el-input
              style="width: 80%"
              v-model="ruleForm.contactAddress"
              placeholder="请输入通信地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="申请类型" prop="applyWayType">
            <div style="width: 80%" class="status">
              <el-radio v-model="ruleForm.applyWayType" label="1"
                >当面</el-radio
              >
              <el-radio v-model="ruleForm.applyWayType" label="2"
                >邮寄</el-radio
              >
              <el-radio v-model="ruleForm.applyWayType" label="3"
                >传值</el-radio
              >
              <el-radio v-model="ruleForm.applyWayType" label="0"
                >其他</el-radio
              >
            </div>
          </el-form-item>
          <div class="title">
            <div class="icon-title"></div>
            <div class="title-txt">所需信息情况</div>
          </div>
          <div class="box-table-one">
            <div style="width: 220px" class="box-table-one-txt">
              * 受理机关名称
            </div>
            <div class="site-box">
               <a-tree-select
                    v-model="ruleForm.organizationId"
                    style="width: 100%"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto',border:'none' }"
                    :tree-data="treeData"
                    @change="changOne"
                    placeholder="请选择受理机关"
                  >
                  </a-tree-select>
            </div>
          </div>
          <div class="box-table-one">
            <div
              style="line-height: 24px; width: 219px"
              class="box-table-one-txt"
            >
              *
              申请公开的政府信息的名称、文号或者便于行政机关查询的其他特征性描述
            </div>
            <el-input
              type="textarea"
              :rows="6"
              placeholder="请输入内容"
              v-model="ruleForm.description"
            >
            </el-input>
          </div>
          <div class="box-table-one">
            <div class="box-table-one-txt">* 获取政府信息的方式</div>
            <div style="width: 100%; padding-left: 14px" class="rideo-box-one">
              <el-radio v-model="ruleForm.getWayType" label="0"
                >当面领取</el-radio
              >
              <el-radio v-model="ruleForm.getWayType" label="1"
                >电子邮件</el-radio
              >
              <el-radio v-model="ruleForm.getWayType" label="2">邮寄</el-radio>
              <el-radio v-model="ruleForm.getWayType" label="3">传真</el-radio>
              <el-radio v-model="ruleForm.getWayType" label="4"
                >阅读、抄录</el-radio
              >
            </div>
          </div>
          <div class="box-table-one">
            <div class="box-table-one-txt">* 政府信息的载体形式</div>
            <div style="width: 100%; padding-left: 14px" class="rideo-box-one">
              <el-radio v-model="ruleForm.carrierFormatType" label="0"
                >纸质文本</el-radio
              >
              <el-radio v-model="ruleForm.carrierFormatType" label="1"
                >数据电文</el-radio
              >
            </div>
          </div>
          <div class="box-table-one">
            <div class="box-table-one-txt">其它需说明的情况</div>
            <div style="width: 100%; padding-left: 14px" class="rideo-box-one">
              <el-input
                v-model="ruleForm.otherConditions"
                placeholder="若有，请在此说明"
              ></el-input>
            </div>
          </div>
           <div class="box-table-one">
            <div class="box-table-one-txt">* 申请人的身份证明(请上传申请人真实、准确的身份证明)</div>
            <div style="width: 100%; padding-left: 14px" class="rideo-box-one">
               <div>
                  <el-upload
                  class="upload-demo"
                   :before-upload="(file) => beforeUpload(file)"
                    slot="append"
                    :show-file-list="false"
                    :multiple="true"
                    action="#"
                    :limit='3'
                    :file-list="fileList"
                  >
                  <div style="display:flex;margin-bottom:10px">
                       <el-button style="margin-right:10px" size="small" type="primary">图片上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，最多只能上传3张，且单张不超过2Mb。</div>
                  </div>
                  
                </el-upload>
                 <div v-for="(item,index) in fileList">
                      <div class="file-one-box">{{item.name}} <div @click="removeImg(index)"><i class="el-icon-close"></i></div></div>
                  </div>
               </div>
            </div>
           
          </div>
        </el-form>
      </el-form>
       <div class="btn-box">
          <el-button
          v-if="codeData.indexOf('304') != -1"
          class="btn"
          type="primary"
          @click="submit"
          :loading="loadingBtn"
          >保存</el-button
        >
       </div>
    </div>
  </div>
</template>

<script>
import { siteOne, save,selectListData } from "../index";
import { regEmail, youbianCode } from "@/utils/reg.js";
import { uploadImg } from "@/utils/common.js";
export default {
  data() {
    let self = this;
    var idNumber = (rule, value, callback) => {
      var regex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (this.ruleForm.certificateType == 0) {
        if (!regex.test(value)) {
          callback(new Error("请输入正确身份证号"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      if (!value || value == "") {
        if (!this.ruleForm.quhao || !this.ruleForm.num) {
          callback(new Error("请填写联系电话"));
        }
      }
      if (value) {
        console.log(value, "sssss");
        var regex = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
        if (!regex.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
        callback();
      } else {
        callback();
      }
    };
    return {
      loadingBtn: false,
      mode: "default", // or 'simple'
      title: "",
      createTime: new Date(),
      type: 1,
      value: undefined,
      resData: [],
      options: [],
      treeData:[],
      loadingBox: false,
      ruleForm: {
        applyType: "0",
        applyWayType:'1',
        getWayType:"0",
        carrierFormatType:"0",
      },
      rules: {
        applyType: [
          { required: true, message: "请选择申请类型", trigger: "blur" },
        ],
        certificateNumber: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
          {
            validator: idNumber,
          },
        ],
        contactName: [
          { required: true, message: "请选择联系人姓名", trigger: "blur" },
        ],
        certificateType: [
          { required: true, message: "请选择证件名称", trigger: "blur" },
        ],
        phone: [
              { required: true, message: "请输入手机号", trigger: "blur" },
              { validator: validatePhone, trigger: ["blur"] }
          ],
        email: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          {
            validator: regEmail,
          },
        ],
        postalCode: [
          { required: true, message: "请输入邮政编码", trigger: "blur" },
          { validator: youbianCode },
        ],
        contactAddress: [
          { required: true, message: "请输入通讯地址", trigger: "blur" },
        ],
        applyWayType: [
          { required: true, message: "请选择申请方式", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入公民姓名", trigger: "blur" }],
        socialCreditCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
        ],
        disposeOffice:[ { required: true, message: "请选择受理机构", trigger: "blur" },],
        statutoryRepresentative: [
          { required: true, message: "请输入法定代表", trigger: "blur" },
        ],
        organizationType: [
          { required: true, message: "请选择类型", trigger: "blur" },
        ],
      },
      isFile: 1,
      id: "",
      listPageData: [],
      richText: "",
      file: "",
      loading: false,
      imageUrl: "",
      value: null,
      height: 0,
      siteData: {},
      codeData: [],
      fileList:[],
    };
  },
  mounted() {
    //this.getList();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
    this.height = (document.documentElement.clientHeight -249)+'px';
    this.getShouLiJiGuan();
    window.onresize = () => {
      return (() => {
         this.height = (document.documentElement.clientHeight -249)+'px';
      })();
    };
  },
  methods: {
    removeImg(index){
        this.fileList.splice(index,1)
    },
    changOne(value,label){
        this.ruleForm.disposeOffice = label[0];
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (["jpg", "png"].indexOf(fileSuffix) == -1) {
        this.$message.error("请上传 jpg、png 格式!");
        return;
      }
       const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('图片大小不能超过 2MB!');
          return;
        }
      uploadImg(file, "site_setting").then((res) => {
        this.fileList.push({url:res.path,name:res.name});
      });
      return false;
    },
     getShouLiJiGuan() {
      selectListData({}).then((res) => {
        if (res.code == 0) {
           let options = JSON.stringify(res.data)
                        .replace(/organizationName/g, "title")
                        .replace(/id/g, "value");
              this.treeData = JSON.parse(options)
        }
      });
    },
    submit() {
      let urlNames = this.fileList;
      console.log(this.fileList,'xxxxxxxxx');
      // for (let index = 0; index < this.fileList.length; index++) {
      //   const element = this.fileList[index];
      //   urlNames.push(element.url)
      // }
      if(urlNames.length == 0){
          this.$message.error('申请人的身份证明最少上传1张')
          return;
      }
      if(!this.ruleForm.organizationId){
         this.$message.error('请选择受理机关')
          return;
      }
      if(!this.ruleForm.description){
        this.$message.error('请输入申请公开的政府信息的名称、文号或者便于行政机关查询的其他特征性描述')
        return;
      }
      this.ruleForm.landlinePhone = '';
      if(this.ruleForm.quhao && !this.ruleForm.num){
          this.ruleForm.landlinePhone = this.ruleForm.quhao
      }
      if(this.ruleForm.num && !this.ruleForm.quhao){
          this.ruleForm.landlinePhone = this.ruleForm.num
      }
      if(this.ruleForm.quhao && this.ruleForm.num){
          this.ruleForm.landlinePhone = this.ruleForm.quhao + "-" +  this.ruleForm.num;
      }
      //let organizationId = this.siteData.mbsOrganizationId;
      this.$refs.ruleFormBase.validate((valid) => {
        if (valid) {
          this.loadingBtn = true;
          save({
            ...this.ruleForm,
            accessory:JSON.stringify(urlNames),
            siteId:sessionStorage.getItem('siteId')
          }).then((res) => {
            if (res.code == 0) {
              this.$router.push({
                path: "/index/applicationlist",
              });
            }
            this.loadingBtn = false;
          });
        }
      });
    },
    getList() {
      let _this = this;
      siteOne({
        id: sessionStorage.getItem("siteId"),
      }).then((res) => {
        this.siteData = res.data;
      });
    },
    backPage() {
      this.$router.push({
        path: "/index/applicationlist",
      });
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #f4f4f6 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search {
    display: flex;
  }
  .back {
    font-size: 18px;
    font-weight: 600;
    color: #000;
  }
  .add-img {
    margin-right: 5px;
    margin-top: -3px;
    cursor: pointer;
  }
}
.log-box {
  //border-bottom: solid 1px #dcdfe6;
  display: flex;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: 24px;
  .log {
    padding: 10px 20px;
    border-top: solid 1px #dcdfe6;
    border-left: solid 1px #dcdfe6;
    cursor: pointer;
    border-bottom: solid 1px #dcdfe6;
  }
  .log:last-child {
    border-right: solid 1px #dcdfe6;
    border-top-right-radius: 10px;
  }
  .log:first-child {
    border-top-left-radius: 10px;
  }
}
.dir {
  height: 1px;
  background: #dcdfe6;
  margin-left: 409px;
  margin-right: 24px;
  margin-top: -1px;
}
.form {
  margin-top: 20px;
  overflow: hidden;
  overflow-y: auto;
}
.status {
  border: solid 1px #dcdfe6;
  border-radius: 4px;
  padding-left: 10px;
}
/deep/ .el-radio__inner::after {
  width: 8px;
  height: 8px;
}
/deep/ .el-radio__inner {
  width: 16px;
  height: 16px;
}
/deep/ .ant-select-selection--single {
  height: 44px;
}
/deep/ .ant-select-selection__rendered {
  line-height: 44px;
}
.choose_template {
  /deep/.el-dialog__title {
    font-size: 16px;
    font-weight: bold;
  }
  /deep/ .el-dialog__body{
            padding-top:10px;
        }
        /deep/ .el-dialog__close{
            font-weight: 600;
        }
  /deep/.el-dialog {
    width: 36%;
  }
  .lod-tips {
    background: #f7f7f7;
    font-size: 12px;
    color: #928f8f;
    line-height: 36px;
    padding: 0 10px;
    border-radius: 4px;
  }
  .choose-path {
    line-height: 50px;
    padding: 0 10px;
    border-radius: 4px;
    border: solid 1px #dcdfe6;
    margin-top: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .template-list {
    border: solid 1px #dcdfe6;
    border-radius: 4px;
    margin-top: 20px;
     .list-box{
                height: 450px;
                overflow-y: auto;
            }
    .title {
      background: #f7f7f7;
    }
    .item {
      font-weight: bold;
      line-height: 52px;
      box-sizing: border-box;
      border-bottom: solid 1px #dcdfe6;
      padding: 0 10px;
      &:last-child {
        border: none;
      }
    }
  }
}
/deep/ .icon-arrow-back:before {
  font-size: 20px;
}
.lod-box {
  display: flex;
  align-items: center;
}
.back-box {
  margin-right: 10px;
  cursor: pointer;
}
.base_seting {
  overflow-y: auto;
  padding: 24px;
  width: 720px;
}
.delete-btn {
  position: absolute;
  margin-left: 10px;
}
.title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .icon-title {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background-color: rgba(23, 109, 230, 1);
  }
  .title-txt {
    color: rgba(23, 109, 230, 1);
    font-size: 16px;
    font-family: HarmonyOS_Sans_SC-regular;
    margin-left: 10px;
    font-weight: 600;
  }
}
/deep/ .el-form-item__label {
  text-align: left;
}
.box-table-one {
  display: flex;
  border: solid 1px #ccc;
  border-left: none;
  border-right: none;
  border-bottom: none;
  /deep/ .el-textarea__inner {
    border: none;
  }
  /deep/ .el-input__inner {
    border: none;
  }
}
.box-table-one-txt {
  width: 220px;
  border-right: solid 1px #ccc;
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: Roboto;
  display: flex;
  align-items: center;
  padding: 10px 10px;
}
/deep/ .ant-select-selection {
  border: none;
}
.rideo-box-one {
   padding-top: 10px;
   padding-bottom: 10px;
}
.box-table-one:last-child {
  border-bottom: solid 1px #ccc;
}
.btn-box{
  padding: 24px 0px;
  position:absolute;
  bottom: 0px;
  padding-bottom: 12px;
  background: #fff;
  width: 80%;
}
.btn {
  margin-left: 24px;
}
.form {
  padding-left: 40px;
  position: relative;
  padding-bottom: 30px;
}
.site-box {
  display: flex;
  align-items: center;
  padding-left: 12px;
  width: 100%;
}
/deep/ input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.upload-demo{
  .el-button--primary{
  background-color: rgba(39, 95, 171, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Microsoft Yahei;
  }
  /deep/ .el-upload{
    text-align: left;
  }
  /deep/ .el-icon-close{
    font-size: 16px;
    color: rgba(144, 147, 153, 1);
    margin-top: 7px;
  }
}
.file-one-box{
  width: 320px;
  height: 26px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 1);
  color: rgba(96, 98, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: Roboto;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  padding: 0 5px;
  justify-content: space-between;
}
.file-one-box:hover{
  background-color: rgba(245, 247, 250, 1);
}
.el-button--primary {
  background: #176de6;
}
.demo-ruleForm{
  overflow-y: auto;
  padding-bottom: 30px;
}
/deep/ .ant-select-selection{
  border-radius:0%;
  box-shadow:none;
}
</style>
